export default function getJobStatusOrSubStatusLabel(job: Job): string {
    return job.substatus_label ? job.substatus_label : job.status_label
}
